import axios from 'axios'
import { SearchUrlParamBuilder } from '@/core/utils'

const ADITIVO_APOSTILA_URL_PATH = 'api/aditivoApostila'
const ITENS_URL_PATH = 'api/aditivoApostila/itens'
const FORNECEDORES_URL_PATH = 'api/aditivoApostila/item/{idItemAditivoApostila}'

class ItensAditivoApostilaApiClient {
	async buscarListagem(filtro, paginacao) {
		const url = new SearchUrlParamBuilder({
			urlPath: `${ITENS_URL_PATH}`,
			filters: filtro,
			pagingAndSorting: paginacao,
		}).build()
		return axios.get(url)
	}

	async buscarFornecedores(idItemAditivoApostila) {
		const url =
			FORNECEDORES_URL_PATH.replace('{idItemAditivoApostila}', idItemAditivoApostila) + '/buscarFornecedores'
		return axios.get(url)
	}

	async alterarFornecedor(idItemAditivoApostila, idFornecedor) {
		const url =
			FORNECEDORES_URL_PATH.replace('{idItemAditivoApostila}', idItemAditivoApostila) + '/alterarFornecedor'
		return axios.put(url, { idItemAditivoApostila, idFornecedor })
	}

	async alterarMarca(idItemAditivoApostila, marca) {
		const url = FORNECEDORES_URL_PATH.replace('{idItemAditivoApostila}', idItemAditivoApostila) + '/alterarMarca'
		return axios.put(url, { idItemAditivoApostila, marca })
	}

	async alterarValor(idItemAditivoApostila, valor) {
		const url = FORNECEDORES_URL_PATH.replace('{idItemAditivoApostila}', idItemAditivoApostila) + '/alterarValor'
		return axios.put(url, { idItemAditivoApostila, valor })
	}

	async removerItens(idsItensAditivoApostila) {
		return axios.delete(ADITIVO_APOSTILA_URL_PATH, { data: { idsItensAditivoApostila } })
	}

	async cancelarDescancelarItens(idAditivoApostila, idsItensAditivoApostila, cancelado) {
		return axios.patch(`${ADITIVO_APOSTILA_URL_PATH}/${idAditivoApostila}/cancelar-descancelar`, {
			idsItensAditivoApostila,
			cancelado,
		})
	}
}

export default new ItensAditivoApostilaApiClient()
